<template>
<div>
    <div class="className1" :id="id" style="height:300px; width:'100%'" ></div>
</div>
</template>

<script>
import echarts from "echarts";
export default {
    props: {
        pointLists:{
            type:Object,
            default(){
                return {}
            }
        },
        showifon:{
            type:Boolean,
            default:false
        },
        id:{
            type:String,
            default:'seriesBar'
        }, 
    },
    watch: {
        showifon:{
            handler(valnew,valold){
                 console.log(valnew,'数据开关深度监控')
                 if(valnew){
                    this.initChart();
                }
            }
        },
        immediate: true,
        deep: true
    },
    
    data() {
        return {
            chart: null
        };
    },
    mounted() {
         this.initChart();
    },
    methods: {
         initChart() {
            const self=this;
            self.chart = echarts.init(document.getElementById(self.id));
            self.chart.setOption(self.getSeriesBarOption());
        },
        getSeriesBarOption(){
         const self=this
         console.log(self.pointLists.name,'self.pointLists.name')
         return {
            backgroundColor: '#FFFFFF',
                    title: {
                        //text: '检查企业信息分析'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    legend: {
                        // data: ['我的达成度', '目标达成度', '平均达成度'],
                        data:[{name:'我的达成度',icon: 'circle',},{name:'目标达成度',icon: 'circle',},{name:'班级平均达成度',icon: 'circle',},],
                        left:'2%',
                        textStyle: {
                            // fontSize: 12,
                            color: '#969696'
                        },
                    },
                    
                    grid: {
                        left: '1%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [{
                        type: 'category',
                        // data: ['指标点1.1', '指标点1.2', '指标点1.3', '指标点1.4'],
                        data:self.pointLists.name,
                        // 坐标轴刻度标签的相关设置  
                        axisLabel: {  
                            interval:0,  
                            rotate:self.pointLists.name.length > 3 ? 45 : 0
                        },
                        axisLine: {show:false,lineStyle:{color:"#323232"}},
                        axisTick: {
                            show: false,
                            color: '#323232'
                        },
                    }],
                    dataZoom: [
                        {
                            type: "slider",
                            show: true,
                            xAxisIndex: [0],
                            left: "7%",
                            bottom: -25,
                            start: 0,
                            end: 90 //初始化滚动条
                        }
                    ],
                    yAxis: [{
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        },
                        axisLine: {show:false,lineStyle:{color:"#969696"}},
                        splitLine:{ show:true, lineStyle:{ color:'#F4F4F4' }},
                        axisTick: {show: false,color: '#323232'},
                    }],
                    series: [{
                        name: '我的达成度',
                        type: 'bar',
                        barGap:'0%',
                        barCategoryGap: "10%",
                        itemStyle: {
                            normal: {
                                color: '#FEC744'
                            },
                        },
                        markPoint: {

                        },
                        barWidth:20,
                        // data: [0.1,0.25,0.12,0.16]
                        data:self.pointLists.ratioMark 
                    }, {
                        name: '目标达成度',
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: 'rgba(254,204,86,.5)'
                            },
                        },
                        barWidth:20,
                        // data: [0.2,0.6,0.2,0.15]
                        data:self.pointLists.targetMark
                    }, {
                        name: '班级平均达成度',
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: '#C2F2DF'
                            },
                        },
                        barWidth:20,
                        // data: [0.16,0.19,1,0.43]
                        data: self.pointLists.pointcourse
                    }]
         }
     },
    }
};
</script>

<style lang="scss">
.className1 {
    width: 100%;
    height: 300px;
    margin-bottom: 30px;
    margin-top: 30px;
}
</style>
